import { Button, Grid } from "@material-ui/core";
import DescriptionIcon from "@material-ui/icons/Description";
import type { EditableCallbackParams } from "ag-grid-community";

type Props = EditableCallbackParams;

export const LOTOLinkButton = ({ data }: Props) => {
	if (data.id !== -1) {
		return (
			<Grid container spacing={1} style={{ alignItems: "center" }}>
				{data?.LOTONumber && (
					<Grid item md={12} xs={12}>
						<Button
							href={`https://web.conformit.com/Print.aspx?Prockey=${data?.LOTONumber}`}
							target="_blank"
							rel="noopener noreferrer"
							fullWidth
							color="primary"
							style={{
								textDecoration: "none",
								fontWeight: 500,
								fontSize: "12px",
								borderRadius: "3px",
							}}
						>
							<DescriptionIcon />
						</Button>
					</Grid>
				)}
			</Grid>
		);
	} else return <></>;
};
